import styles from './Footer.module.css';

const Footer = () => {
  return <footer className={styles.footer}>©MixelinSoft 2024</footer>;
};

export default Footer;
